import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";

import { useStudent } from "../../api/studentApi";
import { translator } from "../../utils/translator";
import { QuestionTypeArray } from "../../types/qna";
import { MultiFileUpload } from "../../components/FileUpload";
import { useCreateQuestion } from "../../api/qnaApi";

const templates = {
  request: `1. 요청내용 : 

2. 연수생 인적사항
 - 이름 : 
 - 연수번호 : 
 - 연수과정 : 
 - 일반 or 특별 :
 - 주중 or 주말 : 
 - 반(없으면 미기재) : 
 - 연수기간 : 

3. 연수생 지도자 인적사항
 - 이름 : 
 - 연락처 : 
 
4. 현장실습기관명 : 
5. 담당자명 : 
6. 담당자 연락처 : 
  `,
  refund: `1. 환불신청서

2. 통장사본

3. 신분증사본
  `,
};

const QnaQuestion = () => {
  const { data, isLoading } = useStudent();
  const student = useMemo(() => data?.student, [data]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [department, setDepartment] = useState("");
  const [type, setType] = useState("");
  const [files, setFiles] = useState<File[]>();
  const { mutateAsync: createQuestion } = useCreateQuestion();
  const navigate = useNavigate();

  const departmentRadioGroup = useMemo(() => {
    if (!student) return [];

    return [
      {
        value: student.department,
        label: `${translator[student.department]}지도사`,
      },
      { value: "all", label: "행정실" },
    ];
  }, [student]);

  const upload = useCallback(async () => {
    if (!title) {
      alert("제목을 입력하세요.");
      return;
    }
    if (!content) {
      alert("내용을 입력하세요.");
      return;
    }
    if (!department) {
      alert("담당부서를 선택하세요.");
      return;
    }
    if (!type) {
      alert("의견구분을 선택하세요.");
      return;
    }
    if (!email || !phone) {
      alert("연락받을 메일 혹은 전화번호를 입력하세요.");
      return;
    }

    await createQuestion({
      title,
      content,
      department: department === "all" ? ["life", "pro"] : [department],
      type,
      email,
      phone,
      files,
    });
    alert("성공적으로 등록되었습니다.");
    navigate("..");
  }, [title, content, department, type, email, phone, files, createQuestion]);

  useEffect(() => {
    if (student) {
      setEmail(student.email);
      setPhone(student.phone);
    }
  }, [student]);

  useEffect(() => {
    if (type === "refund") {
      setDepartment("all");
      setContent(templates.refund);
    } else if (type === "request") {
      setContent(templates.request);
    } else {
      setContent("");
    }
  }, [type]);

  if (isLoading) return <p>로딩 중...</p>;

  return (
    <div className="wideContent">
      <Link to="..">
        <button className="moveButton">뒤로가기</button>
      </Link>
      <div className="binary-grid">
        <>
          <p>연수번호</p>
          <p>{student.user_code}</p>
        </>
        <>
          <p>이름</p>
          <p>{student.name}</p>
        </>
        <>
          <p>이메일</p>
          <p>{student.email}</p>
          {/* <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled
          /> */}
        </>
        <>
          <p>전화번호</p>
          <p>{student.phone}</p>
          {/* <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled
          /> */}
        </>
        <>
          <p>의견구분</p>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <RadioGroup
              row
              value={type}
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              {QuestionTypeArray.map((type) => (
                <FormControlLabel
                  key={type}
                  value={type}
                  control={<Radio />}
                  label={translator[type]}
                />
              ))}
            </RadioGroup>
            <Link to="https://forms.gle/pU1FWP2LHHGMtNRs5" target="_blank">
              <button>공문요청</button>
            </Link>
            <Link to="https://forms.gle/ZpYMpyiEN1HGozyC7" target="_blank">
              <button>환불요청</button>
            </Link>
          </div>
        </>
        <>
          <p>담당부서</p>
          <RadioGroup
            row
            value={department}
            onChange={(e) => {
              setDepartment(e.target.value);
            }}
          >
            {departmentRadioGroup.map((department) => (
              <FormControlLabel
                key={department.label}
                value={department.value}
                control={<Radio />}
                label={department.label}
                onClick={() => setDepartment(department.value)}
              />
            ))}
          </RadioGroup>
        </>
        <>
          <p>제목</p>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </>
        <>
          <p>내용</p>
          <textarea
            style={{ height: "200px" }}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </>
        <>
          <p>첨부파일</p>
          <MultiFileUpload
            files={files}
            setFiles={setFiles}
            filename="question"
          />
        </>
      </div>
      <button onClick={upload}>제출</button>
    </div>
  );
};

export default QnaQuestion;
